import {Box, Typography} from '@mui/material';
import {t} from 'i18next';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {
  PROJECT_CREATION_PATH,
  setProjectCreationInitiatedFrom,
} from '../../../../redux/slices/projectCreationSlice';
import {RootState} from '../../../../redux/store';
import AurButton from '../../../common/aur-button/AurButton';

const HotLeadsFormSuccess = () => {
  const stringPath = 'projectCreation.hotLeadsFormSuccess.';
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const projectCreationInitiatedFrom = useSelector(
    (state: RootState) => state.projectCreation.projectCreationInitiatedFrom
  );
  const returnToButtonHandler = () => {
    switch (projectCreationInitiatedFrom) {
      case PROJECT_CREATION_PATH.ClientOverview:
        dispatch(setProjectCreationInitiatedFrom(null));
        navigate('/welcome-single-client');
        break;
      case PROJECT_CREATION_PATH.ClientDetails:
        dispatch(setProjectCreationInitiatedFrom(null));
        navigate('/clients/details');
        break;
    }
  };
  const getButtonLabel = () => {
    switch (projectCreationInitiatedFrom) {
      case PROJECT_CREATION_PATH.ClientOverview:
        return t(stringPath + 'clientOverviewButton');
      case PROJECT_CREATION_PATH.ClientDetails:
        return t(stringPath + 'clientDetailsButton');
    }
  };

  return (
    <Box className="hot-leads-form-success">
      <Box className="hot-leads-form-success-content">
        <Typography className="typo-text display2_size">
          {t(stringPath + 'title')}
        </Typography>
        <Typography className="typo-text subhead3_size hot-leads-success-content">
          {t(stringPath + 'content')}
        </Typography>
        <AurButton
          label={getButtonLabel()}
          type="continue"
          size="Large"
          dataTestId="ReturntoButton"
          onClick={returnToButtonHandler}
        />
      </Box>
    </Box>
  );
};

export default HotLeadsFormSuccess;
